import { NetworkItem } from '@shared/modals/connect-metamask-modal/connect-metamask-modal.interface';
import { CEX_NETWORKS, DEX_NETWORKS } from '@shared/constants/networks-settings';
import { CexNamesEnum, NetworkNamesEnum } from '@shared/enums/networks.enum';
import { FormValidators } from '@shared/services/FormValidators';
import { Validators } from '@angular/forms';
import { DexNamesEnum } from '@shared/enums/dex-names.enum';
import { CoingeckoDex } from './coingecko-info';


export const NETWORKS_LIST = DEX_NETWORKS
    .sort((a, b) => (a.isDisabled ? 1 : 0) - (b.isDisabled ? 1 : 0))
    .reduce((acc, curr) => {
    acc[curr.network] = curr;
    return acc;
}, []);

export enum NetworksAssets {
    'ethereum' = 'Ethereum',
    'binance-smart-chain' = 'BSC',
    'fantom' = 'Fantom',
    'avalanche' = 'Avalanche',
    'harmony-shard-0' = 'Harmony',
    'polygon-pos' = 'Polygon'
}

export const [
    SUPPORTED_NETWORKS,
    SUPPORTED_CEXES,
    NetworksWithMakers,
    NetworksWithHolders,
    WITH_PRIVATE,
]: [
    NetworkItem<NetworkNamesEnum>[],
    NetworkItem<CexNamesEnum>[],
    NetworkNamesEnum[],
    NetworkNamesEnum[],
    NetworkNamesEnum[]
] = [...DEX_NETWORKS, ...CEX_NETWORKS].reduce((acc, curr) => {
    const item: NetworkItem = {
        name: curr.fullName,
        networkAlias: curr.networkAlias,
        iconName: curr.iconName,
        network: curr.network,
    }
    if (curr.chainId) {
        item['chainId'] = curr.chainId;
    }
    acc[curr.isCex ? 1 : 0].push(item);

    if (curr.isMakers) {
        acc[2].push(curr.network);
    }
    if (curr.isHolders) {
        acc[3].push(curr.network);
    }
    if (curr.isPrivate) {
        acc[4].push(curr.network);
    }
    return acc;
}, [[],[],[],[],[]]);

export const NetworksForTransferBundler = [
    NetworkNamesEnum.solana,
    NetworkNamesEnum.solana_dev,
    NetworkNamesEnum.eth,
    NetworkNamesEnum.bsc,
]

// network === NetworkNamesEnum.solana ? [
//     FormValidators.notEmptyOrWhitespace,
//     FormValidators.isSolanaAddresses,
//     FormValidators.checkDuplicateAddresses(null, DexNamesEnum.raydium),
// ] : network === NetworkNamesEnum.ton ? [
//     Validators.required,
//     FormValidators.notEmptyOrWhitespace,
//     FormValidators.isTonAddresses,
//     FormValidators.checkDuplicateAddresses(null),
// ] : network === NetworkNamesEnum.tron ? [
//     Validators.required,
//     FormValidators.notEmptyOrWhitespace,
//     FormValidators.isBase58Addresses,
//     FormValidators.checkDuplicateAddresses(null),
// ] : [
//     FormValidators.notEmptyOrWhitespace,
//     FormValidators.isEthereumAddresses,
//     FormValidators.checkDuplicateAddresses(null),
// ]

export const NetworkAddressValidators = {
    [NetworkNamesEnum.solana]: [
        Validators.required,
        FormValidators.notEmptyOrWhitespace,
        FormValidators.isSolanaAddresses,
        FormValidators.checkDuplicateAddresses(),
    ],
    [NetworkNamesEnum.ton]: [
        Validators.required,
        FormValidators.notEmptyOrWhitespace,
        FormValidators.isTonAddresses,
        FormValidators.checkDuplicateAddresses(),
    ],
    [NetworkNamesEnum.tron]: [
        Validators.required,
        FormValidators.notEmptyOrWhitespace,
        FormValidators.isBase58Addresses,
        FormValidators.checkDuplicateAddresses(null),
    ],
    [NetworkNamesEnum.xrpl]: [
        Validators.required,
        FormValidators.notEmptyOrWhitespace,
        FormValidators.isXrpAddresses,
        FormValidators.checkDuplicateAddresses(),
    ],
    [NetworkNamesEnum.solana_dev]: [
        Validators.required,
        FormValidators.notEmptyOrWhitespace,
        FormValidators.isSolanaAddresses,
        FormValidators.checkDuplicateAddresses(),
    ],
}

export const CustomNetworkAddressValidators = [
    Validators.required,
    FormValidators.notEmptyOrWhitespace,
    FormValidators.isEthereumAddresses,
    FormValidators.checkDuplicateAddresses(null),
]

export const NetworkKeysValidators = {
    [NetworkNamesEnum.solana]: [
        Validators.required,
        FormValidators.notEmptyOrWhitespace,
        FormValidators.isSolanaKeys,
        FormValidators.checkDuplicateKeys(DexNamesEnum.raydium),
    ],
    [NetworkNamesEnum.ton]: [
        Validators.required,
        FormValidators.notEmptyOrWhitespace,
        FormValidators.isTonKeys,
        FormValidators.checkDuplicateKeys(),
    ],
    [NetworkNamesEnum.xrpl]: [
        Validators.required,
        FormValidators.notEmptyOrWhitespace,
        FormValidators.isXrpKeys,
        FormValidators.checkDuplicateKeys(),
    ],
    [NetworkNamesEnum.solana_dev]: [
        Validators.required,
        FormValidators.notEmptyOrWhitespace,
        FormValidators.isSolanaKeys,
        FormValidators.checkDuplicateKeys(DexNamesEnum.raydium),
    ],
}

export const CustomNetworkKeysValidators = [
    Validators.required,
    FormValidators.notEmptyOrWhitespace,
    FormValidators.isEthereumKeys,
    FormValidators.checkDuplicateKeys(),
]

export const COINGECKO_DEX: CoingeckoDex[] = DEX_NETWORKS.filter(network => network.coingeckoName).reduce((acc, currentNetwork) => {
    if (!currentNetwork.dexes) return acc;
    const network = currentNetwork.network;
    const platformNetworkName = currentNetwork.coingeckoName;
    currentNetwork.dexes.map(networkDex => {
        if (networkDex.coingeckoDex) {
            const dex = networkDex.dex;
            const coingeckoDex = networkDex.coingeckoDex;
            acc.push({ dex, coingeckoDex, network, platformNetworkName });
        }
    })
    return acc;
}, [])
